export default "__VITE_ASSET__Cxvnb18V__"